var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRobotsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "qnu0tmchra"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.537255 0 0 0 0 0.545098 0 0 0 0 0.552941 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "v2kklt4sib"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#qnu0tmchra)",
    transform: "translate(-580 -716)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#v2kklt4sib)",
    transform: "translate(580 716)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E36510",
    stroke: "#E36510",
    d: "M7.15.048c1.273 0 3.433.573 3.508 3.43.064 2.424-1.288 3.479-2.284 3.925.058.002.115.002.171.002 3.396 0 2.406-2.618 4.239-2.76.08-.007.16-.01.236-.01 1.716 0 2.197 1.569 2.224 2.389.04 1.25-.471 3.556-3.428 3.637-.056.002-.11.002-.165.002-2.307 0-3.324-1.314-3.76-2.287-.09 3.599 2.614 2.547 2.759 4.41.15 1.906-1.526 2.433-2.38 2.458l-.129.002c-1.273 0-3.43-.572-3.508-3.427C4.569 9.387 5.93 8.335 6.926 7.89l-.177-.002c-3.399 0-2.41 2.621-4.242 2.764-.08.006-.16.01-.235.01C.558 10.662.074 9.09.05 8.272c-.04-1.25.471-3.559 3.425-3.637.056-.002.11-.002.165-.002 2.315 0 3.33 1.322 3.763 2.295.092-3.613-2.617-2.555-2.762-4.418C4.491.602 6.167.078 7.021.05l.13-.002",
    transform: "translate(2.353 2.353)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotsIcon);
export default __webpack_public_path__ + "static/media/robots-icon.b2d9d66acd738e85a16bf422ed3b4e23.svg";
export { ForwardRef as ReactComponent };